<template>
    <div>
        <v-card-title>
            Список подразделений
            <v-spacer></v-spacer>
            <div>
                <v-btn large color="green" to="/subdivisions/create">
                    Добавить подразделение
                </v-btn>
            </div>
        </v-card-title>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="subdivisions"
                      :options.sync="options"
                      :server-items-length="totalElements"
                      item-key="id"
                      :loading="loading"
                      loading-text="Загрузка ..."
                      :footer-props="{'items-per-page-options':[20, 30, 50]}"
        >
            <template v-slot:body="{ items }">
                <tbody>
                <tr>
                    <td>
                        <v-text-field v-model="filter.id" type="text"></v-text-field>
                    </td>
                    <td>
                        <v-text-field v-model="filter.name" type="text"></v-text-field>
                    </td>
                    <td>
                        <v-text-field v-model="filter.percentageOfReceivedRequests" type="text"></v-text-field>
                    </td>
                    <td></td>
                </tr>
                <tr v-for="item in items" :key="item.id">
                    <td width="300">{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td width="160">{{ item.percentageOfReceivedRequests }}</td>
                    <td width="160">
                        <v-icon small @click="$router.push(`/subdivisions/${item.id}/edit`)">mdi-pencil</v-icon>
                        <v-dialog v-model="deleteDialog[item.id]" max-width="320">
                            <template v-slot:activator="{ on }">
                                <v-icon class="ml-4" small color="red" v-on="on">mdi-delete</v-icon>
                            </template>
                            <v-card>
                                <v-card-text class="text-center pt-7">Удалить выбранный элемент?</v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="deleteDialog[item.id] = false">Отмена</v-btn>
                                    <v-btn color="red" text @click="deleteItem(item.id)">Удалить</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import SubdivisionService from "../_services/SubdivisionService";

    export default {
        name: "SubdivisionsGrid",
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'Имя', value: 'name'},
                    {text: 'Процент заявок', value: 'percentageOfReceivedRequests'}
                ],
                subdivisions: [],
                loading: true,
                options: {
                    sortBy: ['name']
                },
                totalElements: 0,
                filter: {},
                deleteDialog: {}
            }
        },
        watch: {
            options: {
                handler() {
                    this.fetchGrid();
                },
                deep: true
            },
            filter: {
                handler() {
                    this.fetchGrid();
                },
                deep: true
            },
        },
        methods: {
            fetch() {
            },
            fetchGrid() {
                this.loading = true;
                SubdivisionService.getAll(this.options, this.filter).then(data => {
                    this.subdivisions = data.content;
                    this.totalElements = data.totalElements;
                    this.loading = false;
                });
            },
            deleteItem(id) {
                SubdivisionService.delete(id).then(() => {
                    this.fetchGrid();
                });
            }
        },
        created() {
            this.fetch();
            this.$store.dispatch('loading', false);
        },
        beforeCreate() {
            this.$store.dispatch('loading', true);
        }
    };
</script>
